import Swiper from "swiper";

// ハンバーガーメニュー
const humMenu = () => {
	const menu = document.querySelector('#menu');
	const menuBtn = document.getElementById('menu-btn');

	menuBtn.addEventListener('click', () => {
		if (menuBtn.classList.contains('active')) {
			menuBtn.classList.remove('active');
			menu.classList.remove('active');
		} else {
			menuBtn.classList.add('active');
			menu.classList.add('active');
		}
	});
}

// headerのマージンを自動で付与する
const headerMargin = () => {
	const header = document.getElementById("header-height");
	const headerHeight = header.clientHeight;
	const body = document.querySelector("body");
	const addMargin = document.querySelectorAll(".header-margin-add");

	for (let i = 0; i < addMargin.length; i++) {
		addMargin[i].style.marginTop = headerHeight + "px";
	}
};

// トップメインビジュアルスライダー
const topMvSwiper = () => {
	const swiper = new Swiper(".bg-mv", {
		loop: true,
		effect: 'fade',
		slidesPerView: 1,
		speed: 3000,
		autoplay: {
			delay: 3000,
		},
	});
}

// トップ商品スライダー
const topProductSwiper = () => {
	const swiper = new Swiper(".top-product-swiper", {
		loop: true,
		slidesPerView: 3,
		centeredSlides: true,
		spaceBetween: 20,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		breakpoints: {
			576: {
				slidesPerView: 1,
				centeredSlides: true,
			},
		},
	});
};

// 商品ページのアイテム上部の余白を相殺し、トップかジャンプした際ヘッダーに隠れないようにする
const itemTopMargin = () => {
	const header = document.getElementById("header-height");
	const addWhiteSpace = document.querySelectorAll(".anchorlink-margin");
	if (header && addWhiteSpace) {
		const headerHeight = header.clientHeight;
		for (let i = 0; i < addWhiteSpace.length; i++) {
			addWhiteSpace[i].style.paddingTop = headerHeight + "px";
			addWhiteSpace[i].style.marginTop = -headerHeight + "px";
		}
	}
};

// 採用フォームコントロール
const recruitFormControll = () => {
	const formJobType = document.querySelector(".form-job-type");
	if (formJobType) {
		formJobType.readOnly = true;
		formJobType.value = new URLSearchParams(window.location.search).get('title');
	}
}


window.addEventListener('load', () => {
	humMenu();
	topMvSwiper();
	topProductSwiper();
});

document.addEventListener("DOMContentLoaded", () => {
	headerMargin();
	itemTopMargin();
	recruitFormControll();
});

window.addEventListener("resize", () => {
	headerMargin();
	itemTopMargin();
});
